import RichMarkdownContent from "../Announcements/RichMarkdownContent";

interface PageHeaderProps {
  title: string;
  description?: string;
}

export default function PageHeader({ title, description }: PageHeaderProps) {
  return (
    <header className="mb-4 pb-2">
      <h1 className="text-2xl sm:text-3xl font-bold text-gray-900">
        {title}
      </h1>
      {description && (
        <p className="mt-1 text-sm text-gray-600">
          <RichMarkdownContent>
            {description}
          </RichMarkdownContent>
        </p>
      )}
    </header>
  );
}
